import { ICalendarSettings, defaultCalendarSettings } from '../../classes/calendar';
import { ICalendarAppText, defaultText } from '../../custom/classes/calendar-text';
import { ActionType, ICalendarStateAction } from '../../classes/calendar-actions';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function calendarTextReducer(state: ICalendarAppText = defaultText, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.RequestText: {
            return { ...state, requesting: true } as ICalendarAppText;
        }
        case ActionType.ReceiveText: {
            return { ...state, ...action.value, requesting: false, apiError: null } as ICalendarAppText;
        }
        case ActionType.ErrorApiText: {
            console.log(action.value);

            return { ...state, ...action.value, requesting: false, apiError: action.value } as ICalendarAppText;
        }
        default:
            return state;
    }
}
